import { BikeleasingNewsDTO, BikeleasingNewsListDTO } from 'probonio-shared-ui/api';
import { apis, useTenantQuery } from 'probonio-shared-ui/module/api';

export function useBikeleasingNews(enabled: boolean) {
  return useTenantQuery<BikeleasingNewsListDTO>(
    ['bikeleasing', 'benefit', 'news'],
    tenantId =>
      apis.bikeLeasingV2
        .listBikeleasingNews({
          tenantId,
        })
        .then(res => res.data),
    { enabled },
  );
}

export function useBikeleasingNewsArticle(articleId: string, enabled: boolean) {
  return useTenantQuery<BikeleasingNewsDTO>(
    ['bikeleasing', 'benefit', 'news', articleId],
    tenantId =>
      apis.bikeLeasingV2
        .getBikeleasingNewsArticle({
          tenantId,
          articleId,
        })
        .then(res => res.data),
    { enabled },
  );
}
